var _defs, _circle, _path, _g, _g2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1, .st2 {\n        fill: none;\n      }\n\n      .st3, .st4, .st5 {\n        isolation: isolate;\n      }\n\n      .st4 {\n        font-size: 11px;\n      }\n\n      .st4, .st5 {\n        fill: #0384fc;\n        font-family: Mina-Bold, Mina;\n        font-weight: 700;\n      }\n\n      .st6 {\n        fill: #e20000;\n      }\n\n      .st5 {\n        font-size: 5.1px;\n      }\n\n      .st7 {\n        clip-path: url(#clippath);\n      }\n\n      .st2 {\n        stroke: #f8bd00;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 20.2,
    y: 13.3,
    width: 42.6,
    height: 34
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 41.5,
    cy: 41.5,
    r: 40.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-55.8,104.1v-8.8h4.8c.3,0,.5.2.7.4.2.2.4.5.5.9s.2.8.2,1.3v1.1c0,.3-.2.6-.2.7,0,.2-.2.3-.4.4s-.3.2-.3.2h-.3l1.7,3.5h-1.9l-1.5-3.3-1.5-.2v3.5h-1.7v.3h0ZM-54.1,99.2h2.4s.2,0,.3-.2l.2-.4v-.6c0-.5,0-.8-.2-1,0-.2-.4-.3-.6-.3h-2v2.5h-.1ZM-48.2,104.1l3-8.8h1.9l2.9,8.8h-1.8l-.6-1.9h-2.9l-.6,1.9h-1.9ZM-45.3,100.6h2l-1-3.1-1.1,3.1h0ZM-39.1,104.1v-8.8h1.7v8.8h-1.7ZM-35.7,104.1v-8.8h1.7l3.5,5.7v-5.7h1.7v8.8h-1.7l-3.5-5.6v5.6h-1.7ZM-27.1,104.1v-6.9c0-.3,0-.6.2-.9.1-.3.3-.5.4-.6.2,0,.4-.2.6-.3h.7c2.1,0,3.4,0,3.9.2v1.4h-3.9s-.2,0-.2.2v1.9h3.6v1.5h-3.6v3.6h-1.7ZM-19.9,104.1v-8.8h4.8c.3,0,.5.2.7.4.2.2.4.5.5.9s.2.8.2,1.3,0,.8-.1,1.1-.2.6-.2.7c0,.2-.2.3-.4.4s-.3.2-.3.2h-.3l1.7,3.5h-1.9l-1.5-3.3-1.5-.2v3.5h-1.7s0,.3,0,.3ZM-18.2,99.2h2.4s.2,0,.3-.2c0,0,.1-.2.2-.4v-.6c0-.5,0-.8-.2-1-.1-.2-.4-.3-.6-.3h-2v2.5h-.1ZM-12.1,99.7v-1.1c0-.3,0-.7.1-.9,0-.3.1-.5.2-.7,0-.2.2-.4.3-.6s.2-.3.3-.4.3-.2.4-.3c.2,0,.3-.2.5-.2h3c.2,0,.4,0,.6.2s.3.2.5.4c.2,0,.3.3.4.6,0,.2.2.5.3.8,0,.3.2.7.2,1.1v2.9c0,.4,0,.8-.2,1.1,0,.3-.2.6-.4.8-.2.2-.3.4-.5.5s-.4.2-.6.3h-3.2c-.2,0-.4,0-.6-.2-.2,0-.3-.2-.5-.4-.2-.2-.3-.3-.4-.6-.1-.2-.2-.5-.3-.8,0-.3-.1-.6-.2-1v-1.6h.1,0ZM-10.5,99.7v1.2c0,.3,0,.6.2.8,0,.2.2.4.3.5.2,0,.3.2.5.2h.8c.5,0,.9,0,1.1-.2.2,0,.4-.4.6-.8,0-.4.2-1,.2-1.8v-2c0-.2-.2-.4-.2-.5s-.2-.2-.3-.3h-2c-.1,0-.3,0-.3.2,0,0-.2.2-.3.3,0,0-.1.3-.2.5v1.8l-.3.2h0ZM-3.7,99.6v-1.4c0-.4,0-.8.3-1.2,0-.4.3-.7.5-1s.5-.5.8-.6c.3-.2.8-.2,1.2-.2H.8c.5,0,1,0,1.6.3v1.3H-1.2c-.2,0-.3,0-.4.2s-.2.2-.3.4c0,0,0,.3-.2.6v1.8c0,1.2,0,1.9.3,2.3.2.4.6.6,1.2.6s.3,0,.5,0h.4s.2,0,.3-.2h.2v-1.6H-.2v-1.1c.5-.2,1.2-.3,2.1-.3s.5,0,.8,0v5h-1.2l-.5-.6s-.2,0-.2.2-.2,0-.3.2H-.8c-.5,0-.9,0-1.2-.2-.4-.2-.6-.4-.8-.6-.2-.3-.4-.6-.5-1s-.2-.8-.2-1.2v-1.5h-.2v-.2h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.4,44.3h14.3v-6.7l-19.8-23-19.8,22.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.8,14.6v29.7h5.5M44.3,22.9l3.1,3.4v3.6l-3.1-3.5v-3.6h0ZM49.4,28.9l3.1,3.5v3.6l-3.1-3.5v-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.4,30.1l3,3.4v3.6l-3.1-3.5v-3.6h0ZM54.4,34.7l3,3.4v3.6l-3.1-3.5v-3.6h0ZM49.4,36l3,3.4v3.6l-3.1-3.5v-3.6h0ZM39.2,22.9l-3.1,3.5v3.6l3-3.5v-3.7h0ZM34,28.9l-3,3.4v3.6l3-3.5v-3.6h0ZM29,34.7l-3,3.4v3.6l3-3.5v-3.6h0ZM39.1,30.1l-3,3.4v3.6l3-3.5v-3.6h0ZM34,36l-3,3.4v3.6l3-3.5v-3.6h0ZM39.1,37.2l-3,3.4v3.6l3-3.5v-3.6h0ZM44.4,37.2l3,3.4v3.6l-3.1-3.5v-3.6h0Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(22.9 52.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "THE NEXT STEP")))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(19 63.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "LISTINGS")))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: -9.7,
    y: -12.5,
    width: 19.4,
    height: 7.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white_logo.0e0d1c4787eb4f7d8c0ceb60754ff701.svg";
export { ForwardRef as ReactComponent };